<script>
import Layout from '@layouts/main.vue'
import analyticsService from '@utils/analytics-service'

export default {
  page: {
    title: 'Support',
    meta: [{ name: 'description', content: 'The Support page.' }],
  },
  components: { Layout },
  mounted() {
    analyticsService.trackPageView('Support')
  },
}
</script>

<template>
  <Layout>
    <h1>Support</h1>
    <p>The best ways to get to us if you encounter an issue are email and our Discord server.</p>

    <h3>FAQ</h3>
    <p>Have questions? We might have answers in our <a href="https://app.inventorybot.io/app/faq">FAQ</a></p>

    <h3>Email</h3>
    <p><a href="mailto:support@inventorybot.io" target="_blank">support@inventorybot.io</a></p>

    <h3>Discord</h3>
    <p><a href="https://discord.gg/6bnCjKyZf3" target="_blank">Inventory Bot Discord Community (support channel)</a></p>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
</style>

